import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { Button, Modal, Row, Col, Dropdown } from 'react-bootstrap'
import CONSTANTS, { fullMonthTH } from '../../constants/constants'
import config from '../../config'
import Cookies from 'js-cookie'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import UserTransactionModal from './UserTransactionModal'
import UserRefereeModal from './UserRefereeModal'
import UserPointTransactionModal from './UserPointTransactionModal'
import { getUserPoints } from '../../services/wallet'
import { formatPrice, validateNumberOnly, validateTextOnly } from '../../helpers/utils'
import BannedUser from './components/BannedUser'
import { getDateDDMMYYYY } from './utils'
import { getCouponSafeCreditBalance } from '../../services/credit'
import UserCouponSafeCreditTransactionModal from './UserTransactionCouponSafeCredit'

const getDaysInMonth = (y, m) => {
  return new Date(y, m, 0).getDate()
}

const getDays = (month, year) => {
  let allDays = []
  const limitDay = getDaysInMonth(Number(year), Number(month))
  for (let i = 1; i <= limitDay; i++) {
    allDays.push(i)
  }
  return allDays
}

const getStartYear = new Date().getFullYear() - 20 + 543 // อายุต้องมากกว่า 20 ปี และ เปลี่ยน ค.ศ เป็น พ.ศ

const getGender = (gender) => {
  if (gender === 'other') return 'UNSPECIFIED'
  return gender.toUpperCase()
}

const getYears = (startYear) => {
  let years = []
  while (startYear <= getStartYear) {
    years.push(startYear++)
  }
  return years
}

export const UserModal = ({ userModalVisible, setUserModalVisible, selectedUser, setSelectedUser, onClose }) => {
  const dispatch = useDispatch()

  const BANK = CONSTANTS.banks

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [bankName, setBankName] = useState('')
  const [bankNo, setBankNo] = useState('')
  const [address, setAddress] = useState({})
  const [phone, setPhone] = useState('')
  const [orderDetail, setOrderDetail] = useState({
    count: null,
    totalLottery: null,
  })
  const [userPoint, setUserPoint] = useState(null)
  const [nickName, setNickname] = useState('')
  const [gender, setGender] = useState('')
  const [birthDay, setBirthDay] = useState({
    year: '',
    month: '',
    day: '',
  })
  const [pointBalance, setPointBalance] = useState(0)
  const [couponSafeCreditBalance, setCouponSafeCreditBalance] = useState(0)
  const [rounds, setRounds] = useState([])
  const [roundDate, setRoundDate] = useState('')
  const [isTransacitonModalOpen, setIsTransactionModalOpen] = useState(false)
  const [isDisplaySuspendContent, setIsDisplaySuspendContent] = useState(false)
  const [countReferee, setCountReferee] = useState(0)
  const [isRefereeModalOpen, setIsRefereeModalOpen] = useState(false)
  const [isPointTransaction, setIsPointTransaction] = useState(false)
  const [isCouponSafeCreditTransaction, setIsCouponSafeCreditTransaction] = useState(false)

  useEffect(() => {
    if (userModalVisible) {
      setFirstName(selectedUser.firstName)
      setLastName(selectedUser.lastName)
      setBankName(selectedUser.ownerBankName)
      setBankNo(selectedUser.ownerBankNo)
      setAddress(selectedUser.address)
      setPhone(selectedUser.phone)
      setNickname(selectedUser.nickName)
      setGender(getGender(selectedUser?.gender))
      setBirthDay({
        year: selectedUser.birthDay?.year,
        month: selectedUser.birthDay?.month,
        day: selectedUser.birthDay?.day,
      })
    }
  }, [
    selectedUser.address,
    selectedUser.birthDay?.day,
    selectedUser.birthDay?.month,
    selectedUser.birthDay?.year,
    selectedUser.firstName,
    selectedUser?.gender,
    selectedUser.lastName,
    selectedUser.nickName,
    selectedUser.ownerBankName,
    selectedUser.ownerBankNo,
    selectedUser.phone,
    userModalVisible,
  ])

  useEffect(() => {
    const getUserOrder = async (userId) => {
      dispatch({ type: 'loading_show' })
      try {
        const response = await fetch(
          `${config.apiAdminGateway}/api/v3/admin/orders/summary/count?userId=${userId}&status=SUCCESS&roundDate=${roundDate}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              Authorization: `Bearer ${Cookies.get('accessToken')}`,
            },
          },
        ).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)

        const { totalOrder, totalLottery } = response
        setOrderDetail({ count: totalOrder, totalLottery })
      } catch (error) {
        console.error(error)
        setOrderDetail({ count: null, totalLottery: null })
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    }

    const getPointByUser = async (userId) => {
      try {
        dispatch({ type: 'loading_show' })
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/points?userId=${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())
        if (response.status.code !== 0) throw new Error(response.status.description)
        setPointBalance(Number(response.data.balance))
      } catch (error) {
        console.error(error)
        setPointBalance(Number(0))
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    }

    if (selectedUser.id) {
      getUserOrder(selectedUser.id)
      getPointByUser(selectedUser.id)
    }
  }, [dispatch, selectedUser.id, roundDate])

  useEffect(() => {
    const getCountReferee = async (userId) => {
      dispatch({ type: 'loading_show' })
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/users/${userId}/referee/count`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        if (response.status.code !== 0) throw new Error(response.status.description)
        setCountReferee(response.data.total)
      } catch (error) {
        console.error(error)
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    }
    if (selectedUser.id) {
      getCountReferee(selectedUser.id)
    }
  }, [dispatch, selectedUser.id])

  const getUserPoint = useCallback(
    async (userId) => {
      dispatch({ type: 'loading_show' })
      try {
        const point = await getUserPoints(userId)

        setUserPoint(
          Number(point).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
        )
      } catch (error) {
        console.error(error)
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    },
    [dispatch],
  )
  const getCouponBalance = useCallback(
    async (userId) => {
      try {
        dispatch({ type: 'loading_show' })
        const response = await getCouponSafeCreditBalance(userId)
        setCouponSafeCreditBalance(Number(response))
      } catch (error) {
        console.error(error)
        setCouponSafeCreditBalance(Number(0))
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    },
    [dispatch],
  )

  useEffect(() => {
    if (selectedUser.id) {
      getUserPoint(selectedUser.id)
      getCouponBalance(selectedUser.id)
    }
  }, [dispatch, getCouponBalance, getUserPoint, selectedUser.id])

  useEffect(() => {
    const fetchRounds = async () => {
      try {
        const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/rounds`, {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        }).then((res) => res.json())

        setRounds(response.data)
        setRoundDate(response.data[0].value)
      } catch (error) {
        setRounds([])
      }
    }

    fetchRounds()
  }, [])

  const handleClickUserTransaction = () => {
    setIsTransactionModalOpen(true)
  }

  const handleOpenUserCouponSafeCredit = () => {
    setIsCouponSafeCreditTransaction((prev) => !prev)
  }

  const handleCloseUserTransactionModal = () => {
    setIsTransactionModalOpen(false)
  }

  const handleClickUserReferee = () => {
    setIsRefereeModalOpen(!isRefereeModalOpen)
  }

  const updateUser = async () => {
    try {
      const body = {
        id: selectedUser.id,
        firstName,
        lastName,
        bankNo,
        bankName,
        address,
        phone,
        nickName,
        gender,
        birthDay: new Date(birthDay.year, birthDay.month - 1, birthDay.day).toJSON(),
      }
      dispatch({ type: 'loading_show' })
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/users`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify(body),
      })
      dispatch({ type: 'loading_hide' })

      const statusCode = response.status
      const toJson = await response.json()

      if (statusCode === 200) {
        if (toJson.status.code === 0) {
          const { data: user } = toJson
          setSelectedUser({
            ...user,
            birthDay: {
              year: new Date(user.birthDay).getFullYear(),
              month: new Date(user.birthDay).getMonth() + 1,
              day: new Date(user.birthDay).getDate(),
            },
            ownerBankName: user.bankName,
            ownerBankNo: user.bankNo,
          })

          Swal.fire({
            title: 'เปลี่ยนแปลงข้อมูล สำเร็จ!',
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: Colors.SOFT_BLUE,
            confirmButtonText: 'ปิด',
          })
        } else {
          console.error('Error while trying to fetch orders.', toJson.status.description)
          Swal.fire({
            title: 'เปลี่ยนแปลงข้อมูล ไม่สำเร็จ! \n' + toJson.status.description,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: Colors.LIGHT_RED,
            confirmButtonText: 'ปิด',
          })
        }
      } else {
        console.error('Error while trying to fetch orders.')
        Swal.fire({
          title: 'เปลี่ยนแปลงข้อมูล ไม่สำเร็จ!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: Colors.LIGHT_RED,
          confirmButtonText: 'ปิด',
        })
      }
    } catch (error) {
      dispatch({ type: 'loading_hide' })
      console.error('Error while trying to fetch orders.', error)
      Swal.fire({
        title: 'เปลี่ยนแปลงข้อมูล ไม่สำเร็จ!',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: Colors.LIGHT_RED,
        confirmButtonText: 'ปิด',
      })
    }
  }

  return (
    <Fragment>
      {selectedUser && (
        <Modal className="fade" show={userModalVisible} size="lg" scrollable centered enforceFocus={false}>
          <Modal.Header
            style={
              selectedUser.banExpiredAt && moment(selectedUser.banExpiredAt).isAfter(moment())
                ? { backgroundColor: '#F94687' }
                : { backgroundColor: '#FFFFFF' }
            }
          >
            <Modal.Title>
              ลูกค้า: {selectedUser.userId}{' '}
              {selectedUser.banExpiredAt &&
                moment(selectedUser.banExpiredAt).isAfter(moment()) &&
                `สิ้นสุดการแบน: ${getDateDDMMYYYY(selectedUser.banExpiredAt)}`}
            </Modal.Title>
            <Button
              variant=""
              className="close"
              onClick={() => {
                setUserModalVisible(false)
              }}
            >
              <span>&times;</span>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center align-items-center">
              <h3 className="text-center">แบนลูกค้า</h3>
              <button
                onClick={() => setIsDisplaySuspendContent(!isDisplaySuspendContent)}
                className="btn btn-danger btn-sm ml-4"
              >
                {isDisplaySuspendContent ? 'ปิด' : 'เปิด'}
              </button>
            </div>
            {isDisplaySuspendContent && (
              <BannedUser
                user={selectedUser}
                setUserModalVisible={setUserModalVisible}
                setSelectedUser={setSelectedUser}
                onClose={onClose}
              />
            )}
            <hr />
            <Row className="my-1 align-items-center">
              <Col sm={3}>ชื่อ</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ชื่อ"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={3}>นามสกุล</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="นามสกุล"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>ชื่อเล่น</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ชื่อเล่น"
                  value={nickName}
                  onChange={(e) => setNickname(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>เพศ</Col>
              <Col sm={9}>
                <Dropdown>
                  <select
                    className="form-control"
                    style={{ color: Colors.DARK_GREY }}
                    onChange={(value) => {
                      setGender(value.target.value)
                    }}
                    value={gender}
                  >
                    <option value="" disabled hidden>
                      เลือกเพศ
                    </option>
                    <option value="MALE"> ชาย </option>
                    <option value="FEMALE"> หญิง </option>
                    <option value="UNSPECIFIED"> ไม่ระบุ </option>
                  </select>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>ปี-เดือน-วัน</Col>
              <Col sm={9}>
                <Row>
                  <Col sm={4}>
                    <Dropdown>
                      <select
                        className="form-control"
                        style={{ color: Colors.DARK_GREY }}
                        onChange={(value) => {
                          setBirthDay((state) => ({
                            ...state,
                            year: Number(value.target.value - 543),
                          }))
                        }}
                        value={birthDay?.year + 543}
                      >
                        {getYears(getStartYear - 80).map((item) => (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Dropdown>
                  </Col>
                  <Col sm={4}>
                    <Dropdown>
                      <select
                        className="form-control"
                        style={{ color: Colors.DARK_GREY }}
                        onChange={(value) => {
                          setBirthDay((state) => ({
                            ...state,
                            month: Number(value.target.value),
                          }))
                        }}
                        value={birthDay?.month}
                      >
                        {fullMonthTH.map((item, i) => (
                          <option value={i + 1} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Dropdown>
                  </Col>
                  <Col sm={4}>
                    <Dropdown>
                      <select
                        className="form-control"
                        style={{ color: Colors.DARK_GREY }}
                        onChange={(value) => {
                          setBirthDay((state) => ({
                            ...state,
                            day: Number(value.target.value),
                          }))
                        }}
                        value={birthDay?.day}
                      >
                        {getDays(birthDay.month, birthDay.year).map((item) => (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </Dropdown>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="my-3 align-items-center">
              <Col sm={3}>เบอร์โทรศัพท์</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="เบอร์โทรศัพท์"
                  value={phone}
                  onChange={(e) => {
                    const isNumber = validateNumberOnly(e.target.value)
                    if (isNumber && e.target.value.length <= 10) {
                      setPhone(e.target.value)
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>ธนาคาร</Col>
              <Col sm={9}>
                <Dropdown>
                  <select
                    className="form-control"
                    style={{ color: Colors.DARK_GREY }}
                    onChange={(value) => {
                      setBankName(value.target.value)
                    }}
                    value={bankName || ''}
                  >
                    <option hidden disabled selected value="">
                      ไม่พบข้อมูล
                    </option>
                    {Object.keys(BANK).map((key, i) => {
                      return (
                        <option value={key} key={i}>
                          {BANK[key]}
                        </option>
                      )
                    })}
                  </select>
                </Dropdown>
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>เลขบัญชี</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="เลขบัญชี"
                  value={bankNo}
                  onChange={(e) => {
                    if (validateNumberOnly(e.target.value)) {
                      setBankNo(e.target.value)
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>ที่อยู่</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ที่อยู่"
                  value={address?.addressDetail}
                  onChange={(e) =>
                    setAddress((state) => ({
                      ...state,
                      addressDetail: e.target.value,
                    }))
                  }
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>แขวง/ตำบล</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ที่อยู่"
                  value={address?.subdistrict}
                  onChange={(e) => {
                    if (validateTextOnly(e.target.value)) {
                      setAddress((state) => ({
                        ...state,
                        subdistrict: e.target.value,
                      }))
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>เขต/อำเภอ</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ที่อยู่"
                  value={address?.district}
                  onChange={(e) => {
                    if (validateTextOnly(e.target.value)) {
                      setAddress((state) => ({
                        ...state,
                        district: e.target.value,
                      }))
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>จังหวัด</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ที่อยู่"
                  value={address?.province}
                  onChange={(e) => {
                    if (validateTextOnly(e.target.value)) {
                      setAddress((state) => ({
                        ...state,
                        province: e.target.value,
                      }))
                    }
                  }}
                />
              </Col>
            </Row>
            <Row className="my-1 align-items-center">
              <Col sm={3}>รหัสไปรษณีย์</Col>
              <Col sm={9}>
                <input
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  type="text"
                  placeholder="ที่อยู่"
                  value={address?.zipCode}
                  onChange={(e) => {
                    if (validateNumberOnly(e.target.value)) {
                      setAddress((state) => ({
                        ...state,
                        zipCode: e.target.value,
                      }))
                    }
                  }}
                />
              </Col>
            </Row>
            <div
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: '8px', paddingTop: '8px' }}
            >
              <span>งวดที่ :</span>
              <select
                style={{ padding: '8px', borderRadius: '8px', fontSize: '14px' }}
                value={roundDate}
                onChange={(e) => setRoundDate(e.target.value)}
              >
                <option value="">ทั้งหมด</option>
                {rounds.map((item, i) => {
                  return (
                    <option key={i} value={item.value}>
                      {item.value}
                    </option>
                  )
                })}
              </select>
            </div>
            <Row className="my-2">
              <Col sm={6}>จำนวนออเดอร์ที่สำเร็จ</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{orderDetail.count} ออเดอร์</span>
              </Col>
            </Row>
            <Row className="my-2">
              <Col sm={6}>จำนวนลอตเตอรี่ที่ซื้อสำเร็จ</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{formatPrice(orderDetail.totalLottery)} ใบ</span>
              </Col>
            </Row>
            <Row className="my-2">
              <Col sm={6}>จำนวนนกแคชที่มี</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{userPoint ?? '-'} นกแคช</span>{' '}
                <button
                  className="btn btn-primary"
                  style={{ padding: 0, height: '24px', aspectRatio: '1/1', borderRadius: '50%' }}
                  onClick={handleClickUserTransaction}
                >
                  <span className="fa fa-history" />
                </button>
              </Col>
            </Row>
            <Row className="my-2">
              <Col sm={6}>จำนวนผู้ใช้ที่คุณแนะนำ</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{countReferee || 0} คน</span>{' '}
                <button
                  className="btn btn-primary"
                  style={{ padding: 0, height: '24px', aspectRatio: '1/1', borderRadius: '50%' }}
                  onClick={handleClickUserReferee}
                >
                  <span className="fa fa-users" />
                </button>
              </Col>
            </Row>
            <Row className="my-2">
              <Col sm={6}>จำนวนนกพอยต์สะสมทั้งหมด</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{formatPrice(pointBalance) || 0} พอยต์</span>{' '}
                <button
                  className="btn btn-primary"
                  style={{ padding: 0, height: '24px', aspectRatio: '1/1', borderRadius: '50%' }}
                  onClick={setIsPointTransaction}
                >
                  <span className="fa fa-history" />
                </button>
              </Col>
            </Row>
            <Row className="my-2">
              <Col sm={6}>จำนวนคูปองเครดิตทั้งหมด</Col>
              <Col sm={6} style={{ textAlign: 'right' }}>
                <span>{formatPrice(couponSafeCreditBalance) ?? 0} คูปอง</span>{' '}
                <button
                  className="btn btn-primary"
                  style={{ padding: 0, height: '24px', aspectRatio: '1/1', borderRadius: '50%' }}
                  onClick={handleOpenUserCouponSafeCredit}
                >
                  <span className="fa fa-history" />
                </button>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                setUserModalVisible(false)
              }}
              variant="danger light"
            >
              ยกเลิก
            </Button>
            <Button
              variant="primary"
              disabled={isDisplaySuspendContent}
              onClick={() => {
                updateUser()
              }}
            >
              แก้ไขข้อมูล
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {isTransacitonModalOpen && selectedUser && (
        <UserTransactionModal
          userId={selectedUser.id}
          isOpen={isTransacitonModalOpen}
          onClose={handleCloseUserTransactionModal}
          onWithdrawSuccess={() => getUserPoint(selectedUser.id)}
          points={userPoint}
        />
      )}
      {isRefereeModalOpen && selectedUser && (
        <UserRefereeModal userId={selectedUser.id} isOpen={isRefereeModalOpen} onClose={handleClickUserReferee} />
      )}
      {isPointTransaction && selectedUser && (
        <UserPointTransactionModal
          userId={selectedUser.id}
          isOpen={isPointTransaction}
          pointBalance={formatPrice(pointBalance) || 0}
          onClose={() => setIsPointTransaction(false)}
        />
      )}
      {isCouponSafeCreditTransaction && selectedUser && (
        <UserCouponSafeCreditTransactionModal
          userId={selectedUser.id}
          isOpen={isCouponSafeCreditTransaction}
          couponSafeBalance={formatPrice(couponSafeCreditBalance) || 0}
          onClose={handleOpenUserCouponSafeCredit}
        />
      )}
    </Fragment>
  )
}

export default UserModal
